import { useNetworkQuality, type NetworkQuality } from '@/hooks/useNetworkQuality'

const CONFIG: Record<NetworkQuality, { dot: string; label: string; textClass: string }> = {
  good: {
    dot: 'bg-green-400',
    label: 'Connected',
    textClass: 'text-green-400',
  },
  degraded: {
    dot: 'bg-yellow-400',
    label: 'Weak signal',
    textClass: 'text-yellow-400',
  },
  poor: {
    dot: 'bg-red-400',
    label: 'Offline — saved locally',
    textClass: 'text-red-400',
  },
  offline: {
    dot: 'bg-red-400',
    label: 'Offline — saved locally',
    textClass: 'text-red-400',
  },
}

export function NetworkQualityIndicator() {
  const quality = useNetworkQuality()
  const { dot, label, textClass } = CONFIG[quality]

  return (
    <div
      className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-navy-light/50 text-xs"
      role="status"
      aria-live="polite"
      aria-label={`Network status: ${label}`}
    >
      <span className={`inline-block h-2 w-2 rounded-full ${dot}`} aria-hidden="true" />
      <span className={textClass}>{label}</span>
    </div>
  )
}
